// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__l2AjV","colMin":"styles_colMin__2vqWu"};